export default __webpack_public_path__ + "static/media/chicago_regatta_banner.4b64f75c.jpg";